export default function useIsHuman() {
    const isHuman = ref(false);

    const markAsHuman = () => {
        isHuman.value = true;
        cleanup();
    };
    const passiveOptions: AddEventListenerOptions = { passive: true };

    const cleanup = () => {
        window.removeEventListener('mousemove', markAsHuman);
        window.removeEventListener('mousedown', markAsHuman);
        window.removeEventListener('keydown', markAsHuman);
        window.removeEventListener('scroll', markAsHuman, passiveOptions);
        window.removeEventListener('touchstart', markAsHuman, passiveOptions);
        window.removeEventListener('touchmove', markAsHuman, passiveOptions);
    };

    onMounted(() => {
        if (import.meta.client || import.meta.browser) {
            window.addEventListener('mousemove', markAsHuman);
            window.addEventListener('mousedown', markAsHuman);
            window.addEventListener('keydown', markAsHuman);
            window.addEventListener('scroll', markAsHuman, passiveOptions);
            window.addEventListener('touchstart', markAsHuman, passiveOptions);
            window.addEventListener('touchmove', markAsHuman, passiveOptions);
        }
    });

    onUnmounted(() => {
        cleanup();
    });

    return isHuman;
}
